import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminApp from "./AdminApp";
import AdminForgotPassword from "./AdminForgotPassword";

function AdminRouting() {
  return (
    <Routes>
      <Route path="login" element={<AdminApp />} />
      <Route path="signup" element={<AdminApp />} />
      <Route path="forgot-password" element={<AdminForgotPassword />} />
      <Route path="dashboard" element={<AdminApp />} />
      <Route path="user-approvals" element={<AdminApp />} />
      <Route path="change-requests" element={<AdminApp />} />
      <Route path="login-history" element={<AdminApp />} />
      <Route path="notifications" element={<AdminApp />} />
      <Route path="staff-changes" element={<AdminApp />} />
      <Route path="manager-changes" element={<AdminApp />} />
      <Route path="submit-change" element={<AdminApp />} />
      <Route path="my-changes" element={<AdminApp />} />
      <Route path="content-manager" element={<AdminApp />} />
      <Route path="content-editor" element={<AdminApp />} />
      <Route path="footer-editor" element={<AdminApp />} />
      <Route path="navbar-editor" element={<AdminApp />} />
      <Route path="visa-detail-editor" element={<AdminApp />} />
      <Route path="refund-policy-editor" element={<AdminApp />} />
      <Route path="refund-ratings" element={<AdminApp />} />
      <Route path="visa-offices-editor" element={<AdminApp />} />
      <Route path="embassies-editor" element={<AdminApp />} />
      <Route path="forms-editor" element={<AdminApp />} />
      <Route path="requirements-editor" element={<AdminApp />} />
      <Route path="visa-career-editor" element={<AdminApp />} />
      <Route path="schedule-meeting-editor" element={<AdminApp />} />
      <Route path="meeting-bookings" element={<AdminApp />} />
      <Route path="job-applications" element={<AdminApp />} />
      <Route path="email-settings" element={<AdminApp />} />
      <Route path="government-fee-editor" element={<AdminApp />} />
      <Route path="govt-fee-history-editor" element={<AdminApp />} />
      <Route path="hero-editor" element={<AdminApp />} />
      <Route path="event-editor" element={<AdminApp />} />
      <Route path="passport-editor" element={<AdminApp />} />
      <Route path="/" element={<Navigate to="login" />} />
      <Route path="*" element={<Navigate to="login" />} />
    </Routes>
  );
}

export default AdminRouting;
